import React from "react";
import { Container } from 'react-bootstrap'
import { ASSETS_URL } from '../api/constants'

function CommonBanner({ title, bannerImage }) {
  const bannerStyle = {
    backgroundImage: bannerImage ? `url(${ASSETS_URL}${bannerImage})` : undefined,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };

  return (
    <>
     <div className="common-banner" style={bannerStyle}>
      <Container>
        <h1>{title}</h1>
      </Container>
     </div>
    </>
  )
}
export default CommonBanner